import React from "react";
import { usePageContent } from '../../hooks/usePageContent';

const SitemapPage = () => {
  const { find } = usePageContent('sitemap');
  const c = find('richText') || {};
  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'Sitemap'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className="rich-text" dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default SitemapPage;
